import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionBreakdownComponent } from './components/transaction-breakdown/transaction-breakdown.component';
import { SharedModule } from '../shared/shared.module';
import { CustomCashierComponent } from './components/custom-cashier/custom-cashier.component';
import { CardDetailsComponent } from './components/card-details/card-details.component';
import { CustomAmountComponent } from './components/custom-amount/custom-amount.component';
import { PaymentDetailsComponent } from './components/payment-details/payment-details.component';
import { PaymentMethodsComponent } from './components/payment-methods/payment-methods.component';
import { SavedCardsComponent } from './components/saved-cards/saved-cards.component';
import { UserDetailsService } from '../services/user-details.service';
import { AbortPageComponent } from './components/abort-page/abort-page.component';
import { DynamicFormBuilderModule } from '../dynamic-form-builder/dynamic-form-builder.module';



@NgModule({
  declarations: [
    CustomCashierComponent,
    PaymentMethodsComponent,
    PaymentDetailsComponent,
    CustomAmountComponent,
    CardDetailsComponent,
    SavedCardsComponent,
    TransactionBreakdownComponent,
    AbortPageComponent
  ],
  exports:[
    CustomCashierComponent,
    PaymentMethodsComponent,
    PaymentDetailsComponent,
    CustomAmountComponent,
    CardDetailsComponent,
    SavedCardsComponent,
    TransactionBreakdownComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    DynamicFormBuilderModule
  ],
  providers:[
    UserDetailsService
  ]
})
export class CashierModule { }
